import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Mes notifications"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-buttons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "javascript:void(0);",
      class: "card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 active"
    }, " Lire la suite ")
  ])
], -1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " COURSE TITLE "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " TRAINER "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " PUBLISHED ON "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " ENROLLED "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " PRICE "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    })
  ])
], -1)
const _hoisted_7 = { class: "shadow-none fw-medium ps-0" }
const _hoisted_8 = { class: "mb-10 d-block" }
const _hoisted_9 = { class: "d-flex align-items-center text-muted" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book lh-1 text-primary position-relative top-1 fs-md-15 fs-lg-16" }, null, -1)
const _hoisted_11 = { class: "fw-bold ms-5 me-5" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "dropdown-item d-flex align-items-center",
          href: "javascript:void(0);"
        }, [
          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
          /*#__PURE__*/_createTextVNode(" View ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "dropdown-item d-flex align-items-center",
          href: "javascript:void(0);"
        }, [
          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
          /*#__PURE__*/_createTextVNode(" Edit ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "dropdown-item d-flex align-items-center",
          href: "javascript:void(0);"
        }, [
          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
          /*#__PURE__*/_createTextVNode(" Delete ")
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: course.id
              }, [
                _createElementVNode("th", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/course-details",
                      class: "text-decoration-none fs-md-15 fs-lg-16 fw-bold text-black-emphasis"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(course.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("span", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(course.classes), 1),
                    _createTextVNode(" Classes ")
                  ])
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(course.trainer), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(course.date), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(course.enrolled), 1),
                _createElementVNode("td", _hoisted_15, " $" + _toDisplayString(course.price), 1),
                _hoisted_16
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}